import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {BusinessAdminsRoutingModule} from './business-admins-routing.module';
import {BusinessAdminsComponent} from './business-admins.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {AddBusinessAdminsComponent} from './add-business-admins/add-business-admins.component';


@NgModule({
    declarations: [BusinessAdminsComponent, AddBusinessAdminsComponent],
    imports: [
        CommonModule,
        BusinessAdminsRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ],
    exports: [BusinessAdminsComponent, AddBusinessAdminsComponent]
})
export class BusinessAdminsModule {
}
